import React, { Component } from "react";
import auth from "../../services/authService";
import config from "../../config.json";
import { getMatchBets } from "./../../services/matchBetService";
import RankingTable from "./rankingTable";

class Ranking extends Component {
  state = { ranking: [], isLoaded: false };

  async componentDidMount() {
    const ranking = await getMatchBets(auth.getCurrentUser().id);
    this.setState({  ranking, isLoaded: true });
  }

  render() {
    const { ranking } = this.state;
    const loadingImage = config.imagesUrl + "spinner.gif";

    return (
      <div>
        <h2>Ranking</h2>
        <RankingTable ranking={ranking} />
        {this.state.isLoaded || <div className="center"><img src={loadingImage} alt="Loading..."></img></div>}
      </div>
    );
  }
}

export default Ranking;



// WEBPACK FOOTER //
// ./src/components/ranking/ranking.jsx